import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
import BcTable from '@/components/Table.vue';
import BcMask from '@/components/Mask.vue';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import { Getter } from 'vuex-class';
class UserForm extends CBcDialogForm {
    constructor(form) {
        super();
        const that = this;
        if (form) {
            Object.keys(form).forEach((k) => {
                that[k] = form[k];
            });
        }
    }
}
class RoleForm extends CBcDialogForm {
}
let userInfo = class userInfo extends Vue {
    constructor() {
        super();
        this.searchOptions = {
            username: '',
            rolename: '',
            empNo: '',
            name: '',
            phone: '',
            quickly: '',
        };
        this.userTotal = 0;
        this.currentUser = null;
        this.snackbar = new CBcSnackbar();
        this.dialogRole = new CBcDialog(new RoleForm());
        this.dateMenus = {};
        this.userTypeOptions = [
            {
                text: '正式员工',
                value: 1,
                color: 'success',
            },
            {
                text: '临时员工',
                value: 2,
                color: 'primary',
            },
            {
                text: '三方派遣',
                value: 3,
                color: 'orange',
            },
        ];
        this.fields = [
            {
                name: 'username',
                visible: true,
                type: 'text',
                defaultValue: '',
                rules: ['lengthRequest'],
                label: '用户名',
                placeholder: '请输入用户名',
                md: 6,
                icon: 'person'
            },
            {
                name: 'roleName',
                visible: true,
                type: 'sel',
                defaultValue: '普通用户',
                rules: ['notNull'],
                items: [],
                // items: ['超级管理员', '系统管理员', '管理员', '临床人员', '研发人员', '验收人员', '医护人员', '代理商', '普通用户', '访客用户'],
                label: '角色',
                md: 4,
                icon: 'account-circle'
            },
            {
                name: 'password',
                visible: true,
                type: 'text',
                inputType: 'password',
                defaultValue: '',
                rules: ['notNull'],
                label: '密码',
                placeholder: '请输入密码',
                md: 6,
                icon: 'lock'
            },
            {
                name: 'employeeNo',
                visible: true,
                type: 'text',
                defaultValue: '',
                label: '工号',
                placeholder: '请输入工号',
                rules: [],
                md: 4,
                icon: 'mdi-alpha-n-box'
            },
            {
                name: 'name',
                visible: true,
                type: 'text',
                defaultValue: '',
                label: '姓名',
                placeholder: '请输入姓名',
                rules: [],
                md: 4,
                icon: 'mdi-alpha-m-circle'
            },
            {
                name: 'sex',
                visible: true,
                type: 'sel',
                defaultValue: '',
                items: ['保密', '男', '女'],
                label: '性别',
                rules: [],
                md: 4,
                icon: 'mdi-account-convert'
            },
            {
                name: 'department',
                visible: true,
                type: 'text',
                defaultValue: '',
                label: '部门',
                placeholder: '部门',
                rules: [],
                md: 4,
                icon: 'mdi-alpha-b-circle'
            },
            {
                name: 'position',
                visible: true,
                type: 'text',
                defaultValue: '',
                label: '职位',
                placeholder: '请输入职位',
                rules: [],
                md: 4,
                icon: 'mdi-alpha-z-circle'
            },
            {
                name: 'phone',
                visible: true,
                type: 'text',
                defaultValue: '',
                label: '电话',
                placeholder: '请输入电话',
                rules: ['isPhone'],
                md: 4,
                icon: 'phone'
            },
            {
                name: 'email',
                visible: true,
                type: 'text',
                defaultValue: '',
                label: '邮件',
                placeholder: '请输入邮件',
                rules: ['isEmail'],
                md: 4,
                icon: 'email'
            },
            {
                name: 'userType',
                visible: true,
                type: 'sel',
                defaultValue: '',
                items: this.userTypeOptions,
                itemText: 'text',
                itemValue: 'value',
                label: '用户类型',
                rules: [],
                md: 4,
                placeholder: '请选择用户类型',
                icon: 'mdi-format-list-bulleted-type'
            }, {
                name: 'validityDate',
                visible: true,
                type: 'date',
                defaultValue: '',
                label: '账号有效期',
                md: 4,
                placeholder: '请选择账号有效期',
                icon: 'mdi-calendar-range'
            },
        ];
        this.roles = [];
        this.dataSource = {
            headers: [
                { text: '用户名', value: 'username' },
                { text: '角色', value: 'roleName' },
                { text: '工号', value: 'employeeNo' },
                { text: '姓名', value: 'name' },
                { text: '电话', value: 'phone' },
                { text: '邮件', value: 'email' },
                { text: '性别', value: 'sex' },
                { text: '用户类型', value: 'userType' },
                { text: '账号有效期', value: 'validityDate' },
                { text: '操作', value: 'action', sortable: false },
            ],
            desserts: [],
            isDetail: true,
        };
        this.pagination = {
            current: 10,
            countSum: 10,
            limit: 10,
            items: 10,
            curPre: 1,
        };
        this.rules = {
            num: (val) => {
                const rul = /^(\d+)?\.?\d+$/;
                const flag = rul.test(val) || '该值为非负整数，且不能为空!';
                return flag;
            },
            notNull: (value) => !!value || '内容不能为空',
            lengthRequest: (value) => {
                if (value && value.length <= 3) {
                    return '不能少于3个字符';
                }
                else
                    return true;
            },
            isPhone: (value) => /^1[3-9]\d{9}$/.test(value) || '手机号码有误',
            isEmail: (value) => /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(value) || '邮箱地址有误',
        };
        this.maskValue = {
            isShow: false,
        };
        const that = this;
        that.dialog = new CBcDialog(new UserForm());
    }
    mounted() {
        const that = this;
        that.getUsers();
        that.getRoles();
    }
    onDialogRoleVisibleChanged(v, o) {
        const that = this;
        if (v === o)
            return;
        if (!v) {
            that.$refs.roleForm.reset();
        }
    }
    getRules(value) {
        const arr = [];
        const that = this;
        if (value instanceof Array) {
            value.forEach((item) => {
                if (item && that.rules[item]) {
                    arr.push(that.rules[item]);
                }
            });
        }
        return arr;
    }
    showDialog(type, value) {
        const that = this;
        that.dialog.title = type === 'delete' ? '停用账户' : that.dialog.isCreateType ? '新增用户' : '用户编辑';
        if (type === 'delete') {
            that.dialog.title = '停用账户';
            if (!/sys|system/i.test(that.userInfo.role)) {
                that.snackbar.error('非系统管理员用户不允许该操作！');
                return false;
            }
        }
        else if (type === 'reset') {
            that.dialog.title = '重置密码';
            if (!/admin|sys|system/i.test(that.userInfo.role)) {
                that.snackbar.error('非管理员用户不允许重置密码！');
                return false;
            }
        }
        that.dialog.persistent = true;
        that.dialog.show(type);
        that.fields = that.fields.map((v) => {
            if (v.name === 'roleName')
                v.visible = false;
            else {
                if (that.dialog.isEditType) {
                    v.visible = v.name !== 'password';
                }
                else {
                    v.visible = true;
                }
            }
            v.readonly = that.dialog.isEditType ? v.name === 'username' : false;
            return v;
        });
        that.dialog.form = new UserForm(value);
        if (that.dialog.isEditType)
            that.dialog.form.valid = true;
        console.log('123132', that.dialog.form);
    }
    async save() {
        const that = this;
        const value = that.dialog.form;
        that.maskValue.isShow = true;
        const isCreate = that.dialog.isCreateType;
        let iTitle = isCreate ? '用户注册' : '用户信息修改';
        let method = isCreate ? 'post' : 'put';
        let url = isCreate ? '/api/users/register' : `/api/users/${value.id}`;
        let data = {};
        if (that.dialog.type === 'reset') {
            iTitle = '重置密码';
            method = 'post';
            url = `/api/users/password/reset/${value.id}`;
            data = { password: '123', authorReset: true };
        }
        else if (that.dialog.type === 'delete') {
            iTitle = '停用账户';
            method = 'delete';
            url = `/api/users/${value.id}`;
            data = {};
        }
        else {
            data = { ...value };
            // 非正式员工时，必须维护账号有效性
            if (value.userType !== 1 && !value.validityDate) {
                that.snackbar.error('非正式员工账号有效期不能为空！');
                that.maskValue.isShow = false;
                that.dialog.show(that.dialog.type);
                this.$nextTick(() => {
                    that.showDialog(that.dialog.type, value);
                });
                return false;
            }
        }
        that.axios
            .request({
            method: method,
            url: url,
            data: data,
        })
            .then(() => {
            that.maskValue.isShow = false;
            that.snackbar.success(iTitle + '成功！');
            that.getUsers();
        })
            .catch((e) => {
            that.snackbar.error(iTitle + '失败,' + (e && (e.info || e.result || e.error)));
            that.maskValue.isShow = false;
            that.dialog.show(that.dialog.type);
        });
    }
    async getUsers(value = false) {
        const that = this;
        that.maskValue.isShow = true;
        let user;
        try {
            const params = {
                limit: that.pagination.limit,
                page: that.pagination.curPre,
                ...JSON.parse(JSON.stringify(that.searchOptions || {}), (k, v) => {
                    if (!(!v && String(v).length == 0))
                        return v;
                }),
            };
            user = await that.axios.get('/api/users', { params: params });
        }
        catch (e) {
            that.maskValue.isShow = false;
            return that.snackbar.error('获取用户失败！');
        }
        const dataValue = user.data.result;
        that.dataSource.desserts = [];
        if (dataValue.length) {
            dataValue.forEach((item, index) => {
                if (item.usersInfo && item.usersInfo.validityDate) {
                    item.usersInfo.validityDate = new Date(item.usersInfo.validityDate).format('yyyy-MM-dd');
                }
                ;
                if (item.username !== 'admin')
                    that.dataSource.desserts.push({ ...item.usersInfo, ...item });
            });
        }
        that.userTotal = user.data.sum;
        that.pagination.countSum = user.data.sum;
        that.pagination.items = Math.ceil(user.data.sum / user.data.limit) || 1;
        that.maskValue.isShow = false;
    }
    async getRoles() {
        const that = this;
        try {
            const rolesData = (await that.axios.get('/api/roles')).data;
            that.roles = rolesData.result;
            that.fields = that.fields.map((v) => {
                if (v.name === 'roleName') {
                    v.items = that.roles;
                }
                return v;
            });
        }
        catch (e) {
            console.log('error of get roles:', e);
            that.snackbar.error('获取角色列表出错:' + (e && (e.info || e.result || e.error)));
        }
    }
    limitFun(value) {
        const that = this;
        that.pagination.limit = typeof value === 'number' ? value : that.pagination.countSum;
        that.pagination.curPre = 1;
        that.getUsers();
    }
    pagePreFun(value) {
        const that = this;
        that.pagination.curPre = value;
        that.getUsers();
    }
    showRoleUpdateDialog(item) {
        const that = this;
        that.currentUser = item;
        that.dialogRole.autoClose = false;
        that.dialogRole.persistent = true;
        that.dialogRole.title = '更新用户角色';
        that.dialogRole.form = new RoleForm(item);
        // that.dialogRole.formValid = true
        that.dialogRole.visible = true;
    }
    async updateUserRole() {
        const that = this;
        try {
            if (!(that.dialogRole.form.roleInfo && that.dialogRole.form.roleInfo.id)) {
                that.snackbar.info('请选择角色.');
                return;
            }
            that.axios.post('/api/users/roles', {
                roleId: that.dialogRole.form.roleInfo.id,
                userId: that.dialogRole.form.id,
                userName: that.dialogRole.form.username,
                roleName: that.dialogRole.form.roleInfo.name,
            });
            that.snackbar.success('用户角色更新成功');
            that.dataSource.desserts = that.dataSource.desserts.map((v) => {
                if (v.id === that.dialogRole.form.id) {
                    v.roleInfo = that.dialogRole.form.roleInfo;
                }
                return v;
            });
            that.dialogRole.close();
        }
        catch (e) {
            console.log('update user role error:', e);
            that.snackbar.error('更新用户角色出错:' + (e && (e.info || e.result || e.error)));
        }
    }
    onDateInput(date, fieldName) {
        const that = this;
        if (date) {
            // 处理日期对象，转换为YYYY-MM-DD格式
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            that.dialog.form[fieldName] = `${year}-${month}-${day}`;
        }
        else {
            that.dialog.form[fieldName] = '';
        }
    }
};
__decorate([
    Getter
], userInfo.prototype, "userInfo", void 0);
__decorate([
    Watch('dialogRole.visible')
], userInfo.prototype, "onDialogRoleVisibleChanged", null);
userInfo = __decorate([
    Component({
        name: 'userManger',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
            BcMask,
        },
    })
], userInfo);
export default userInfo;
